<template>
  <div class="main">

    <div class="item">
        <div class="number number1">01</div>
        <h1>如何开户交易</h1>
        <p>新人炒股的第一步就是开户，拥有自己的炒股账户，才可以正式进入股市进行交易。所以大家可以选择一家自己喜欢的证券公司进行开户</p>
        <h2>应用商店搜索</h2>
        <div class="input">
            <span v-for="item in arr1">{{ item }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path d="M19.808 19.4901L16.4067 15.8505C17.7853 14.1901 18.5435 12.1203 18.5435 9.94208C18.5435 4.83036 14.3839 0.670807 9.27079 0.670807C4.15907 0.67152 -0.000488281 4.83036 -0.000488281 9.9428C-0.000488281 15.0545 4.15907 19.2134 9.2715 19.2134C10.6109 19.2126 11.9026 18.9331 13.1101 18.3832C13.4689 18.2198 13.6272 17.7969 13.4639 17.4388C13.3005 17.0787 12.8762 16.9196 12.5195 17.0851C11.4975 17.5501 10.4048 17.7862 9.27079 17.7869C4.94505 17.7869 1.42597 14.2678 1.42597 9.9428C1.42597 5.61706 4.94505 2.09798 9.27079 2.09798C13.5972 2.09798 17.117 5.61706 17.117 9.9428C17.117 11.9784 16.3403 13.9084 14.931 15.3748C14.6578 15.6586 14.6671 16.1101 14.9502 16.3833C14.9716 16.4039 14.9994 16.4118 15.023 16.4296C15.043 16.4581 15.0522 16.491 15.0765 16.5166L18.7653 20.4636C18.9051 20.6141 19.0955 20.6897 19.286 20.6897C19.4607 20.6897 19.6354 20.6263 19.7731 20.4972C20.0612 20.229 20.0769 19.7782 19.808 19.4901Z" fill="#F1C09F"/>
            </svg>
        </div>
    </div>

    <div class="item">
        <div class="number number2">02</div>
        <h1>了解炒股知识</h1>
        <p>开户成功后，也不要盲目的进行股票的交易，可以先来使用以下板块学习一下炒股的基础知识哦。</p>
        <div class="itemb" v-for="item in arr2" 
            :style="{background:item.color}"
            @click.stop.prevent="toApp(item.kind,item.id,item.jump_id)"
            >
            <img :src="'https://cdncos.aigupiao.com/assets/pc/img/2023/'+item.img" :alt="item.name">
            <div class="itemb1">
                <h1>{{ item.name }}</h1>
                <p>{{ item.word }}</p>
            </div>
            <div class="itembt">{{ item.title }}</div>
        </div>
    </div>

    <div class="item">
        <div class="number number3">03</div>
        <h1>查看市场行情</h1>
        <p>对于市场行情的精准把控能够让我们在交易中更加得心应手，形成自己对于行情的理解与分析意识才能算是真正的炒股入门哦。</p>
        <div class="itemb" v-for="item in arr3" 
            :style="{background:item.color}"
            @click.stop.prevent="toApp(item.kind,item.id,item.jump_id)"
            >
            <img :src="'https://cdncos.aigupiao.com/assets/pc/img/2023/'+item.img" :alt="item.name">
            <div class="itemb1">
                <h1>{{ item.name }}</h1>
                <p>{{ item.word }}</p>
            </div>
            <div class="itembt">{{ item.title }}</div>
        </div>
    </div>

    <div class="item">
        <div class="number number4">04</div>
        <h1>选股有方法</h1>
        <p>不知道如何选股？那就来看看下面这几项功能吧。</p>
        <div class="itemc_box">
            <div class="itemc" v-for="item in arr4"
             @click.stop.prevent="toApp(item.kind,item.id,item.jump_id)"
            >
                <img :src="'https://cdncos.aigupiao.com/assets/pc/img/2023/'+item.img" :alt="item.name">
                <h1>{{ item.name }}</h1>
                <p>{{ item.word }}</p>
            </div>
        </div>

    </div>

    <div class="item item5">
        <div class="number number5">05</div>
        <h1>指导更专业</h1>
        <p>平台入驻大量经验丰富、见解独到、资深专业的高手们，给我们剖析市场热点、分析行情走势，利用科学的方法带我们实现技术的飞跃。</p>
        <div class="itemc_box2">
            <div class="itemc2" v-for="item in arr5"
            
            @click.stop.prevent="toApp('person_page',item.id)"
            >
                <img :src="item.img" :alt="item.name">
                <h1>{{ item.name }}</h1>
                <p>{{ item.word }}</p>
                <!-- <div class="kt" @click.stop.prevent="toApp('open_vip',item.id)">开通VIP</div> -->
                <div class="kt_t">{{ item.title }}</div>
                <img class="ico" src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/5bce8ec43c43ed2b302634ffbe4a9382=39X39.png" alt="">
                <!-- <img src="https://img1-cdn-picsh.aigupiao.com/cms_image/2021-08-12/d36da176c360c5be26bf1ade95169f05=30X30.png" alt=""> -->
            </div>
            <div class="itemc2 itemc3">
                <div class="bt1" @click.stop.prevent="toApp('Ranking_of_masters')">高手排行</div>
                <!-- <div class="bt1 bt2" @click.stop.prevent="toApp('Record_Leaderboard')">战绩榜</div> -->
            </div>
        </div>
    </div>









  </div>
</template>


<script>
export default {
	data() {
		return {
			arr1:[
				"东方财富",
				"中信证券",
				"国泰君安"
			],
            arr2:[
                {
                    name:'股市学堂',
                    title:'入门到精通',
                    word:'炒股从入门到精通的干货知识',
                    img:'hbi1.svg',
                    kind:'person_page',
                    o_kind:'live_msg',
                    id:530,
                },
                /* {
                    name:'股民必读',
                    title:'入市必读',
                    word:'新股民入市必读基础知识',
                    img:'hbi2.svg',
                    color:'#EEF8FE',
                    kind:'topic_detail',
                    jump_id:4656,
                }, */
                {
                    name:'爱股学堂',
                    title:'看视频 涨知识',
                    word:'分享从入门到精通的股市视频，每天带你涨知识！',
                    img:'hbi3.svg',
                    color:'#FEEEEE',
                    kind:'person_page',
                    o_kind:'live_msg',
                    id:4562,
                    
                },
                {
                    name:'模拟炒股',
                    title:'虚拟资金炒股',
                    word:'虚拟金币带你体验真实炒股感受，学习高手炒股组合，参加大赛还有机会获得奖励哦',
                    img:'hbi6.svg',
                    color:'#FFEEE7',
                    kind:'replica_match_stock',
                },
                {
                    name:'K线训练营',
                    title:'真人PK 练盘感',
                    word:'真人PK小游戏，以历史K线为依据，提取个股真实历史走势，以限时赛的形式完成模拟交易，快来体验一下吧！',
                    img:'hbi5.svg',
                    color:'#FFE5EE',
                    kind:'kline_game',
                },
            ],
            arr3:[
                {
                    name:'题材复盘',
                    title:'每日涨停题材复盘',
                    word:'题材复盘解析，分析涨停原因，查看盘面亮点',
                    img:'hbii1.svg',
                    kind:'subject_review'
                },
                {
                    name:'龙虎榜',
                    title:'主力动向精准分析',
                    word:'精选榜单，学习买卖思路，发掘市场隐藏热点',
                    img:'hbii2.svg',
                    color:'#FFE9E3',
                    kind:'lhRank'
                },
                {
                    name:'自选股',
                    title:'全平台同步',
                    word:'添加自选，防止遗漏，全面分析',
                    img:'hbii3.svg',
                    color:'#FFE3E3',
                    kind:'Watchlisted',
                },
                {
                    name:'个股排行',
                    title:'多榜单快速筛选',
                    word:'涨跌幅榜等股票排名，快速了解市场热点和个股表现',
                    img:'hbii4.svg',
                    color:'#FED5D5',
                    kind:'stock_rise_rank'
                },
            ],
            arr4:[
                {
                    name:'趋势选股',
                    word:'热点优选股票池，主流机构和量化抱团的活跃股',
                    img:'hbij1.svg',
                    kind:'open_api',
                    jump_id:'STOCK_POOL',
                },
                {
                    name:'热股排行',
                    word:'搜索查询、模拟交易、添加自选和讨论最多的股票排行榜',
                    img:'hbij2.svg',
                    kind:'hot_stock',
                },
                {
                    name:'形态选股',
                    word:'根据K线形态为您筛选股票',
                    img:'hbij3.svg',
                    kind:'AGPSHAPE'
                },
                {
                    name:'智能诊股',
                    word:'基于大数据挖掘，对股票进行评级以及给出您相应建议',
                    img:'hbij4.svg',
                    kind:'open_api',
                    jump_id:'ZG_INDEX',
                },
                {
                    name:'打板策略',
                    word:'监测涨停板，追踪连板股，发现市场热点制定买卖决策',
                    img:'hbij5.svg',
                    kind:'board_stock'
                },
                {
                    name:'研报中心',
                    word:'汇集最新、自选、个股及行业研报，深入了解市场及行业动态',
                    img:'hbij6.svg',
                    kind:'report_center'
                },
            ],
            arr5:[
                {
                    name: '爱股君',
                    title: '段子手、热点解读',
                    word: '热点解读，题材挖掘，兼段子手！',
                    img: 'https://img1-cdn-picsh.aigupiao.com/user/avatar/2025-08-05/151970eca963a201f3f4bb063a122c82.jpg',
                    id: 355,
                },
                {
                    name: '老魚头',
                    title: '次新、狙击热点',
                    word: '老魚头战队擅长波段研究，专研热点。',
                    img: 'https://img1-cdn-picsh.aigupiao.com/upload/user/avatar/94290/240/2eca1a6cd7bf8fe2a6191eaa6d01ce63=240X240.jpg',
                    id: 1149,
                },
                {
                    name: '马哥热点',
                    title: '热点、超短',
                    word: '投研战队擅长捕捉市场热点，挖掘逻辑价值；抓龙头趋势，共筑财富升值！',
                    img: 'https://img1-cdn-picsh.aigupiao.com/user/avatar/2024-08-09/ffb73ac74a2254e0bcf873bb67e0771f.PNG',
                    id: 4563,
                },
                {
                    name: '爱炒股的杨杨',
                    title: '实盘',
                    word: '100w起步，悟道之路！',
                    img: 'https://img1-cdn-picsh.aigupiao.com/user/avatar/2025-02-23/55e948791c000de0cea28bec4b05b335.PNG',
                    id: 4795,
                },
                {
                    name:'阳光金牛',
                    title:'实盘、超短、狙击热点',
                    word:'抓热点做短线 ，重趋势寻突破，看资金与庄共舞。',
                    img:'https://cdn.aigupiao.com/upload/user/avatar/198189/240/15376779995608.jpg',
                    id:574,
                },
            ],
		};
	},
    methods: {
		toApp(kind,id,jump_id) {
            if(id > 0){
                //跳转页面：老师详情页 person_page
                //跳转页面：开通老师vip open_vip
                this.$srH5CallNativeMethodApp('call_Native',{
                    kind: kind,
                    id: id.toString(),
                    o_kind:'live_msg',
                })
            }
            else{
                this.$srH5CallNativeMethodApp('call_Native',{
                    kind: kind,//跳转页面
                    jump_id:jump_id ? jump_id.toString() :'',
                })
            }
		},
	}
}
</script>

<style lang="scss" scoped>
.main{
    background: #FEE7E7;
    padding: 20px 10px;
    min-height: 100vh;


    .item{
        border-radius: 16px;
        background: #FFF;
        padding: 18px 18px 22px;
        position: relative;
        margin-bottom: 20px;
        &::after{
            display: block;
            content: "";
            position: absolute;
            top: 0;
            height: 45px;
            width: 100%;
            border-radius: 16px 16px 0px 0px;
            background: linear-gradient(180deg, #FDF2ED 0%, #FFF 100%);
            left: 0;
        }
        .number{
            color: #FBE5D6;
            text-align: right;
            font-family: DINPro;
            font-size: 40px;
            font-weight: 700;
            position: absolute;
            z-index: 1;
            right: 10px;
            top: 4px;
        }
        >h1{
            color: #3C3C3C;
            font-size: 20px;
            font-weight: 700;
            margin: 0 0 15px;
            position: relative;
            z-index: 1;
        }
        >p{
            color: #A9662C;
            font-size: 15px;
            font-weight: 500;
            line-height: 155%; /* 23.25px */
            margin: 0 0 15px;
        }
        >h2{
            color: #F1C6A9;
            text-align: center;
            font-family: "SF Pro Text";
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin: -7px 0 8px;

        }
        .input{
            height: 45px;
            border-radius: 9px;
            border: 1px solid #F8DBDB;
            background: #FDF1F1;
            display: flex;
            align-items: center;
            padding: 0 10px;
            position: relative;
            span{
                display: inline-flex;
                padding: 4px 7px;
                align-items: center;
                margin-right: 10px;
                color: #FFF;
                text-align: justify;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                border-radius: 4px;
                background: #E4A778;
            }
            svg{
                width: 20px;
                height: 20.019px;
                flex-shrink: 0;
                position: absolute;
                right: 10px;
            }
        }

        .itemb{
            padding: 12px 17px 12px 24px ;
            border-radius: 17.5px;
            background: #FEF7EE;
            margin-bottom: 14px;
            display: flex;
            align-items: center;
            position: relative;
            h1{
                color: #955724;
                text-align: justify;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                margin-bottom: 5px;
            }
            p{
                color: #938A8A;
                text-align: justify;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .itembt{
                position: absolute;
                display: inline-flex;
                padding: 5px 9px;
                justify-content: flex-end;
                align-items: center;
                border-radius: 4.5px 4.5px 4.5px 16.5px;
                background: linear-gradient(90deg, #F09367 0%, #ED704B 100%);
                color: #FFF;
                text-align: right;
                text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.15);
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                right: -3px;
                top: -5px;
            }

            img{
                width: 50px;
                height: 50px;
                flex-shrink: 0;
                margin-right: 18px;
            }
        }

        .itemc_box{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: -7.5px;
        }

        .itemc{
            display: flex;
            width: 48%;
            padding: 18px 10px;
            box-sizing: border-box;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 19px;
            border: 1px solid #FAE2C9;
            background: #FEF7EE;
            flex-shrink: 0;
            margin: 7.5px 0;
            img{
                width: 60px;
                height: 60px;
                flex-shrink: 0;
            }
            h1{
                margin: 10px 0;
                color: #955724;
                text-align: center;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
            p{
                color: #7B7272;
                text-align: justify;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }

        .itemc_box2{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: -12.5px;
        }

        .itemc2{
            display: flex;
            width: 48%;
            border-radius: 10.254px;
            border: 1px solid #EEE;
            box-sizing: border-box;
            background: #FFF;
            flex-direction: column;
            align-items: center;
            padding: 25px 10px 16px;
            margin: 12.5px 0;
            position: relative;
            img{
                width: 56.881px;
                height: 56.789px;
                flex-shrink: 0;
                border-radius: 50%;
            }
            h1{
                margin: 16px 0 3px;
                color: #333;
                text-align: center;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
            .ico{
                width: 16px;
                height: 16px;
                flex-shrink: 0;
                position: absolute;
                left: 87.34px;
                top: 65.86px;
            }
            p{
                color: #696969;
                text-align: center;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-bottom: 10px;
            }
            .kt{
                display: flex;
                height: 29.557px;
                padding: 5px 22px;
                box-sizing: border-box;
                justify-content: center;
                align-items: center;
                gap: 10px;
                flex-shrink: 0;
                border-radius: 16.362px;
                background: linear-gradient(137deg, #FFD27C 5.02%, #CEA045 102.24%);
                color: #FFF;
                text-align: center;
                font-size: 14.032px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
            .kt_t{
                display: inline-flex;
                padding: 2.5px 6px;
                justify-content: center;
                align-items: center;
                top: -10px;
                left: 0;
                position: absolute;
                border-radius: 10.254px 0px;
                background: linear-gradient(138deg, #B4B4B4 2.99%, #575757 98.2%);
                color: #FFF;
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }

        .itemc3{
            border-radius: 10.254px;
            background: linear-gradient(180deg, #FFF 0%, #FEF8F1 100%);
            justify-content: center;
            border: none;
            .bt1{
                border-radius: 20px;
                background: linear-gradient(137deg, #FFD27C 5.02%, #CEA045 102.24%);
                display: flex;
                width: 100px;
                height: 40px;
                justify-content: center;
                align-items: center;
                margin-bottom: 20px;
                flex-shrink: 0;
                color: #FFF;
                text-align: center;
                font-size: 15px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                box-sizing: border-box;
                }
                .bt2{
                    border-radius: 29.5px;
                    border: 1px solid #F3B89C;
                    color:#ED7643;
                    background: #FFF;
                }
        }
    }
    .item5::after{
        display: block;
        content: "";
        position: absolute;
        top: 0;
        height: 45px;
        width: 100%;
        border-radius: 16px 16px 0px 0px;
        background: linear-gradient(180deg, #FFEFB1 0%, #FFF 100%);
        left: 0;
    }
}
</style>